import React from "react";
import CsvImportDialog from "../../components/csv-import-dialog/CsvImportDialog";

const REQUIRED_COLUMNS = [
  "client_first_name",
  "client_last_name",
  "client_mobile_phone_number",
];

const FORMAT_GUIDE = [
  "Dates: DD/MM/YYYY or YYYY-MM-DD",
  "Gender: Male, Female, or NotSpecified",
  "Phone: any format (auto-cleaned, digits only)",
  "Phone type: Mobile, Work, or Home",
  "Opt-in fields: 1 (yes) or 0 (no)",
];

const PREVIEW_COLUMNS = [
  { key: "client_first_name", label: "First Name" },
  { key: "client_last_name", label: "Last Name" },
  { key: "client_email", label: "Email" },
  { key: "client_mobile_phone_number", label: "Phone" },
];

const EXTRA_RESULT_COUNTS = [
  { key: "location_assignments", label: "Location assignments" },
];

/** Client CSV import. All behavior lives in the shared CsvImportDialog. */
export default function ImportClientsDialog({
  open,
  onClose,
  onImportComplete,
}) {
  return (
    <CsvImportDialog
      open={open}
      onClose={onClose}
      onImportComplete={onImportComplete}
      entityPlural="clients"
      entityTitle="Clients"
      subtitle="Upload a CSV to create or update clients in bulk."
      importPath="/clients/import"
      templateFilename="client-import-template.csv"
      requiredColumns={REQUIRED_COLUMNS}
      optionalColumnsHint="Optional: email, phone, gender, birthday, address, location_id, and more. Column names are case-insensitive."
      formatGuide={FORMAT_GUIDE}
      previewColumns={PREVIEW_COLUMNS}
      existingIdKey="existing_client_id"
      extraResultCounts={EXTRA_RESULT_COUNTS}
    />
  );
}
